<template>
	<div>
		<q-carousel
			keep-alive
			:navigation="banners_desktop.length > 1"
			:arrows="banners_desktop.length > 1"
			animated
			:autoplay="10000"
			infinite
			swipeable
			v-model="slide"
			transition-prev="slide-right"
			transition-next="slide-left"
			control-color="white"
			class="banner-height"
			v-if="banners_desktop?.length > 0 && $q.platform.is.desktop"
		>
			<q-carousel-slide
				:name="banner.id"
				class="column no-wrap flex-center"
				:class="banner.url ? 'cursor-pointer' : ''"
				v-for="banner in banners_desktop"
				:key="banner.id"
				:img-src="banner.image_desktop_original"
				:aria-label="
					banner.banner_image_alt_texts?.length ? banner.banner_image_alt_texts[0].alt_text : ''
				"
				role="img"
				@click="openLink(banner)"
			>
			</q-carousel-slide>
		</q-carousel>

		<div
			class="row q-col-gutter-x-md q-pa-md"
			v-if="banners_mobile.length > 0 && $q.platform.is.mobile"
		>
			<div class="col-12">
				<q-carousel
					keep-alive
					:navigation="false"
					:arrows="banners_mobile.length > 1"
					animated
					:autoplay="10000"
					infinite
					swipeable
					v-model="slide"
					transition-prev="slide-right"
					transition-next="slide-left"
					control-color="white"
					height="23vh"
				>
					<q-carousel-slide
						:name="banner.id"
						class="column no-wrap flex-center rounded-carousel"
						:class="banner.url ? 'cursor-pointer' : ''"
						v-for="banner in banners_mobile"
						:key="banner.id"
						:img-src="banner.image_mobile_original"
						:aria-label="
							banner.banner_image_alt_texts?.length
								? banner.banner_image_alt_texts[banner.banner_image_alt_texts.length - 1].alt_text
								: ''
						"
						role="img"
						@click="openLink(banner)"
					>
					</q-carousel-slide>
				</q-carousel>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'BannerContents',

	props: ['origin'],

	data() {
		return {
			slide: null,
			banners_desktop: [],
			banners_mobile: [],
		}
	},

	computed: {
		...mapGetters({
			user_id: 'common/id',
			is_superuser: 'common/is_superuser',
		}),

		getHeight() {
			if (this.$q.screen.lt.md) return '340px'
			else return 'return 255px'
		},
	},

	methods: {
		loadBanners() {
			let banner_type

			switch (this.origin) {
				case 'online_courses':
					banner_type = 1
					break
				case 'trails':
					banner_type = 2
					break
				case 'webinars':
					banner_type = 3
					break
				case 'portfolio':
					banner_type = 5
					break
				case 'podcasts':
					banner_type = 6
					break
				case 'live_classes':
					banner_type = 7
					break
				case 'library':
					banner_type = 8
					break
				case 'news':
					banner_type = 9
					break
				case 'presentials':
					banner_type = 10
					break
				default:
					banner_type = 4
					break
			}

			this.$axios
				.get(`/etraining_banners/banners/get_banner_by_type/?banner_type=${banner_type}`)
				.then((response) => {
					if (response.data.length > 0) {
						this.banners_desktop = response.data
							.sort((a, b) => b.id - a.id)
							.filter((e) => e.image_desktop_original)
						this.banners_mobile = response.data
							.sort((a, b) => b.id - a.id)
							.filter((e) => e.image_mobile_original)
						this.slide = response.data[0].id
					}
				})
				.catch((e) => {
					console.log(e)
				})
		},

		async openLink(banner) {
			if (this.$hasGtm && this.$gtm.enabled()) {
				this.$gtm.trackEvent({
					event: 'banner click',
					category: !this.origin ? 'home banner' : `${this.origin} banner`,
					action: banner.url,
					label: this.$route.path,
					value: 0,
					noninteraction: false,
				})
			}
			if (banner.url) {
				let url = new URL(banner.url)
				if (banner.use_token && url.origin !== process.env.SITE_URL) {
					if (this.is_superuser) {
						return this.$q.notify({
							message: this.$t(
								'Somente usuários que não possuem privilégios de super usuário podem acessar este link'
							),
							type: 'negative',
							icon: 'fal fa-exclamation-triangle',
							position: 'top',
						})
					}
					try {
						this.$q.loading.show()
						const { data } = await this.$axios.get(
							`/webservices/request_user_token/?user_id=${this.user_id}`
						)
						window.open(`${url.origin}${url.pathname}?access_token=${data.token}${url.hash}`)
					} catch (error) {
						this.$q.notify({
							message: this.$t('an_unexpected_error_has_occurred_try_again'),
							type: 'negative',
							icon: 'fal fa-exclamation-triangle',
							position: 'top',
						})
					} finally {
						this.$q.loading.hide()
					}
				} else {
					if (url.origin === process.env.SITE_URL) this.$router.push({ path: url.pathname })
					else window.open(banner.url)
				}
			}
		},
	},

	created() {
		this.loadBanners()
	},
}
</script>

<style lang="scss" scoped>
@media (max-width: $breakpoint-sm-max) {
	.banner-height {
		height: 255px;
	}
}
@media (min-width: $breakpoint-md-min) {
	.banner-height {
		height: 340px;
	}
}
.rounded-carousel {
	border-radius: 20px;
}
</style>
